import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React from 'react'
import {renderIf} from 'views/Shared'
import {ImagePlaceholder} from "../../../conts/imageBase64";
import {renderIfElse} from "../../Shared";
import {PiCertificate} from "react-icons/pi";
import {ItemInformation} from "../../AppLocals/Organization/OrganizationEntity";
import {Image} from "antd";

const renderMedal = ({ renderContextMenu } = {}) => (item, index) => {

    const tags = Array.from(item?.tags ?? [])

    return (
        <Translate key={index}>
            {(t) => (
                <div className="w-full flex flex flex-col custom-item-render rounded-lg shadow-md hover:scale-xs relative">
                    {renderIfElse(
                        item?.avatar,
                        <Image
                            preview={false}
                            src={item?.avatar}
                            fallback={ImagePlaceholder}
                            style={{ height: 180, maxHeight: 200 }}
                            className="rounded-t-lg object-cover bg-no-repeat"
                            wrapperClassName="w-full rounded-lg"
                        />,
                        <div style={{ height: 150 }} className="flex flex-center background-100 rounded-l-lg rounded-r-0">
                            <PiCertificate size={50} style={{color: '#dddddd'}}/>
                        </div>
                    )}
                    <div className="p-3 h-full border-b border-color-50 rounded-b-lg flex flex-col gap-1 flex-1">
                        <h2 className="mb-1 font-bold text-lg text-color-000 max-lines-1 leading-snug">
                            {getTitle(item)}
                        </h2>
                        <ItemInformation showIcon={true} label="level" value={item?.lvl_number} className="text-sm italic"/>
                        <ItemInformation showIcon={true} label="total_count" value={item?.total_count} className="text-sm italic"/>
                        {renderIf(
                            tags.length,
                            <ItemInformation showIcon={true} label="tags" value={tags.map(({ tags }) => `#${tags}`).join(', ')} className="text-sm italic"/>
                        )}
                    </div>
                    {renderIf(
                        _.isFunction(renderContextMenu),
                        <div className="absolute right-5 top-5 contextIcon">
                            {renderContextMenu(item)}
                        </div>
                    )}
                </div>
            )}
        </Translate>
    )
}

export default renderMedal
